import angular from 'angular';

class MessageRouteCtrl {
    /*@ngInject*/
    constructor($translate, $sessionStorage, i18nService) {
        this.$translate = $translate;
        this.$sessionStorage = $sessionStorage;
        this.i18nService = i18nService;
    }

    $onInit() {
        let vm = this;

        vm.i18nService.setCurrentLang(vm.$translate.use());

        vm.includes = {
            message: require('./message/message.html'),
        };

        if (!vm.keepFilter) {
            vm.$sessionStorage.messageHistorySearchCriteria = null;
        }

        vm.getTableHeight = function (gridApi) {
            var rowHeight = 30;
            var headerHeight = 30;
            var scrollHeight = 20;
            var footerHeight = 32;
            return {
                height:
                    gridApi.core.getVisibleRows(gridApi.grid).length * rowHeight +
                    headerHeight +
                    scrollHeight +
                    footerHeight +
                    'px',
            };
        };
    }
}

angular.module('dashboard').component('messageRoute', {
    templateUrl: require('./message-route.html'),
    controller: MessageRouteCtrl,
    bindings: {
        keepFilter: '<',
        specificForm: '<',
    },
});
